import { UserSearchOrderDirections, UserSearchOrderOptions } from '../../enums/user'
import { User } from '../../interfaces/user.interface'
import { AppLocale } from '../../i18n/config'
import request from '../config/request'

import requestBack from '../config/request-back'
import { requireInformedRequesterId } from '../utils/requester'

/**
 * @deprecated Utilize a função `registerUser()`
 */
const signup = async (authData: any) => {
	let response = await request({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_HOST + `/signup`,
		data: authData
	})

	return response
}

const registerUser = async (userData: {
	company_id: string,
	first_name: string,
	last_name: string,
	email: string,
	cellphone?: string,
	birth_date?: string,
	sex?: number,
	role?: number,
	country?: string,
	informedRequesterId?: string,
}) => {
	const informedRequesterId = requireInformedRequesterId(userData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = userData

	let response = await request({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/register-user`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true
	})

	return response
}

const verifyCodeEmail = async (authData: any) => {
	let response = await request({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_HOST + `/verify-code-email`,
		data: authData
	})

	return response
}

const verifyToken = async ({ token }: { token: string }) => {
	try {
		const response = await request({
			method: 'POST',
			url: process.env.REACT_APP_SERVICES_HOST + `/verify-token`,
			data: { token }
		})
		return { isValid: true, data: response }
	} catch (error: any) {
		return {
			isValid: false,
			error: error?.response?.data?.error || 'Erro ao verificar o token'
		}
	}
}

const newUser = async (authData: any) => {
	const informedRequesterId = requireInformedRequesterId(authData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = authData ?? {}

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/new-user`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true
	})

	return response
}

const updateUser = async (authData: any) => {
	const informedRequesterId = requireInformedRequesterId(authData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = authData ?? {}

	let response = await requestBack({
		method: 'PUT',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/update-user`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true
	})

	return response
}

const finishUserRegister = async (authData: any) => {
	let response = await requestBack({
		method: 'PATCH',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/finish-user-register`,
		data: authData,
		vtAuth: true
	})

	return response
}

const getUserByEmail = async (email: any) => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/user-by-email/${email}`,
		vtAuth: true
	})

	return response
}

const getUserByCellphone = async (cellphone: any) => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/user-by-cellphone/${cellphone}`,
		vtAuth: true
	})

	return response
}

const sendSurveys = async (authData: any) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/send-surveys`,
		vtAuth: false,
		data: authData,
	})

	return response
}

const getUsersByCompany = async (filter: any, page: number,) => {
	let query = "?page=" + page
	if (filter.company_id) {
		query += "&company_id=" + filter.company_id
	}
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/users-by-company` + query,
		vtAuth: true,
	})

	return response
}

/**
 * @deprecated Esta função foi depreciada. Utilize `searchUsers().`
 */
const findUser = async (filter: any) => {
	let query = "?company_id=" + filter.company_id
	if (filter.search) {
		query += "&search=" + filter.search
	}
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/search-user-by-company` + query,
		vtAuth: true,
	})

	return response
}

const searchUsers = async (searchParameters: {
	company_id: string,
	term?: string,
	statuses?: number[],
	sexes?: number[],
	ageRanges?: number[][],
	groups?: string[],
	orderBy?: UserSearchOrderOptions,
	direction?: UserSearchOrderDirections,
	inactivationReasonCodes?: string[]
}): Promise<{ data: User[], total_items: number }> => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/search-users`,
		data: {...searchParameters},
		vtAuth: true,
	})

	return response;
}

type ToggleUserStatusPayload = {
	id: string;
	informedRequesterId?: string;
	currentUserStatus: number;
	reasonCode?: string;
	customReasonText?: string | null;
};

type ToggleUserStatusResponse = {
	success?: boolean;
	action?: string;
	message?: string;
	user?: User;
};

const toggleUserStatus = async (payload: ToggleUserStatusPayload): Promise<ToggleUserStatusResponse> => {
	const informedRequesterId = requireInformedRequesterId(payload?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...rest } = payload

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/toggle-user-status`,
		data: {
			...rest,
			informedRequesterId,
		},
		vtAuth: true,
	})

	return response;
}

type PatchUserData = Partial<User> & {
	cellphone?: string | null;
	informedRequesterId?: string;
};

export type PatchMeData = {
	id: string;
	first_name?: string;
	last_name?: string;
	country?: string;
	birth_date?: string;
	sex?: number;
	locale?: AppLocale;
};

const patchMe = async (userData: PatchMeData): Promise<User> => {
	return requestBack({
		method: 'PATCH',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/me`,
		data: userData,
		vtAuth: true,
	});
};

const patchUser = async (userData: PatchUserData): Promise<User> => {
	const informedRequesterId = requireInformedRequesterId(userData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = userData ?? {}

	let response = await requestBack({
		method: 'PATCH',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/patch-user`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true,
	})

	return response;
}

const getUsersByGroup = async (filter: any, page: number,) => {
	let query = "?page=" + page
	if (filter.company_id) {
		query += "&company_id=" + filter.company_id
	}
	if (filter.group_id) {
		query += "&group_id=" + filter.group_id
	}
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/users-by-company-and-group` + query,
		vtAuth: true,
	})

	return response
}

const getUserById = async (id: any) => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/user-by-id/${id}`,
		vtAuth: true
	})

	return response
}

const resendConfirmationCode = async (email: string) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_HOST + `/resend-confirmation-code`,
		data: { email: email },
	})

	return response
}

const verifyUserCellphone = async (cellphone: string) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/login-with-cellphone`,
		data: { cellphone: cellphone },
	})

	return response
}

const startCellphoneAuth = async (cellphone: string) => {
	return requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/auth/cellphone/start`,
		data: { cellphone },
	})
}

const confirmCellphoneAuth = async (cellphone: string, code: string, session: string) => {
	return requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/auth/cellphone/confirm`,
		data: { cellphone, code, session },
	})
}

const sendEmailAuthAdmin = async (email: string) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/send-email-auth-admin`,
		data: { address: email },
	})

	return response
}

export { signup, verifyCodeEmail, verifyToken, newUser, getUserByEmail, sendSurveys, getUsersByCompany, findUser, searchUsers, toggleUserStatus, patchUser, patchMe, updateUser, finishUserRegister, getUsersByGroup, getUserById, resendConfirmationCode, verifyUserCellphone, startCellphoneAuth, confirmCellphoneAuth, sendEmailAuthAdmin, getUserByCellphone, registerUser }
